var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C12.6641 2.5 13.25 3.08594 13.25 3.75V4.53125C16.1016 5.07812 18.25 7.61719 18.25 10.625V11.3672C18.25 13.2031 18.9141 15 20.125 16.3672L20.3984 16.6797C20.75 17.0703 20.8281 17.5781 20.6328 18.0469C20.4375 18.4766 19.9688 18.75 19.5 18.75H4.5C3.99219 18.75 3.52344 18.4766 3.32812 18.0469C3.13281 17.5781 3.21094 17.0703 3.5625 16.6797L3.83594 16.3672C5.04688 15 5.75 13.2031 5.75 11.3672V10.625C5.75 7.61719 7.89844 5.07812 10.75 4.53125V3.75C10.75 3.08594 11.2969 2.5 12 2.5ZM13.7578 21.7969C13.2891 22.2656 12.6641 22.5 12 22.5C11.3359 22.5 10.6719 22.2656 10.2031 21.7969C9.73438 21.3281 9.5 20.6641 9.5 20H12H14.5C14.5 20.6641 14.2266 21.3281 13.7578 21.7969Z",
    fill: "#494968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.5C15.8431 3.5 14.5 4.84315 14.5 6.5C14.5 8.15685 15.8431 9.5 17.5 9.5C19.1569 9.5 20.5 8.15685 20.5 6.5C20.5 4.84315 19.1569 3.5 17.5 3.5Z",
    fill: "#FF3B30",
    stroke: "#EEF1FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationAlert);
export default __webpack_public_path__ + "static/media/icon_notification_alert.d596932feb0aa0a1bedc3af81f21a245.svg";
export { ForwardRef as ReactComponent };